import { render } from "./adjust-weight-section.vue?vue&type=template&id=77afe4da&scoped=true&ts=true"
import script from "./adjust-weight-section.vue?vue&type=script&lang=ts"
export * from "./adjust-weight-section.vue?vue&type=script&lang=ts"

import "./adjust-weight-section.vue?vue&type=style&index=0&id=77afe4da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77afe4da"]])

export default __exports__